import React from 'react'
import { CustomModal } from '../../../../../components/common/CustomModal'
import { ReactSelectOption } from '../../../../../types'
import { CompanyShopsAndEmployeesMigrationResponse } from 'types/migration'
import { CompanyCollectionDetailsContent } from './CompanyCollectionDetailsContent'
interface CompanyCollectionDetailsModalProps {
  open: boolean
  onClose: () => void
  selectedShops?: ReactSelectOption[]
  selectedCompany?: ReactSelectOption
  companyMigrationDetails?: CompanyShopsAndEmployeesMigrationResponse
  onSyncCompanyData?: () => void
}

export const CompanyCollectionDetailsModal: React.FC<CompanyCollectionDetailsModalProps> = ({
  open,
  onClose,
  selectedShops,
  selectedCompany,
  companyMigrationDetails,
  onSyncCompanyData,
}) => {
  return (
    <CustomModal open={open} onClose={onClose} size="medium">
      <CustomModal.Header title="Company migration details" onClose={onClose} />
      <CustomModal.Content>
        <CompanyCollectionDetailsContent
          onSyncCompanyData={onSyncCompanyData}
          selectedCompany={selectedCompany}
          companyMigrationDetails={companyMigrationDetails}
          selectedShops={selectedShops}
        />
      </CustomModal.Content>
      <CustomModal.Footer cancelText="Close" onCancel={onClose} />
    </CustomModal>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/MigrateCompanyProducts/CompanyCollectionDetailsModal/index.tsx